import type { ApiConfig } from '../../types'

export const withdrawalHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 100,
  order: 'desc',
  range: 90 * 24 * 60 * 60 * 1000, // 90 days in milliseconds
  requiresRange: true,
  type: 'withdrawal-history',
} as const satisfies ApiConfig
